import React, { useEffect } from 'react';
import { Router } from 'react-router-dom';
import Provider from 'react-redux/es/components/Provider';
import jssExtend from 'jss-extend';
import { create } from 'jss';
import '@fake-db';
import { StylesProvider, jssPreset, createGenerateClassName } from '@material-ui/styles';
import history from '@history';
import { FuseAuthorization, FuseLayout, FuseTheme } from '@fuse';

import { Auth } from './auth';
import store from './store';
import AppContext from './AppContext';
import routes from './fuse-configs/routesConfig';
import LicenseKey from './licenseKey/LicenseKey';
import ConfigProvider from './ConfigProvider';

import SocketCliente from './socket-client/SocketClient';
import Sockc from './socket-client/SocketComponent';
import { initializeMaintenance } from './main/login/utils/maintenanceUtils';
const jss = create({
	...jssPreset(),
	plugins: [...jssPreset().plugins, jssExtend()],
	insertionPoint: document.getElementById('jss-insertion-point')
});

const generateClassName = createGenerateClassName();

const App = () => {
	// Initialize secure storage maintenance on app startup
	useEffect(() => {
		// Run maintenance in the background
		setTimeout(() => {
			initializeMaintenance();
		}, 1000); // Delay to avoid blocking initial render
	}, []);

	return (
		<ConfigProvider>
			<AppContext.Provider value={{ routes }}>
				<StylesProvider jss={jss} generateClassName={generateClassName}>
					<Provider store={store}>
					<LicenseKey>
						<Auth>
							<Router history={history}>
								<FuseAuthorization>
									<FuseTheme>
										<Sockc socket={SocketCliente}>
											<FuseLayout />
										</Sockc>
									</FuseTheme>
								</FuseAuthorization>
							</Router>
						</Auth>
					</LicenseKey>
				</Provider>
			</StylesProvider>
		</AppContext.Provider>
	</ConfigProvider>
	);
};

export default App;
